import type { StoreConnectionResponse } from "@go-novus/admin-api";

/**
 * Tenant 的店铺接入读模型。形状直接取自 admin API 契约，
 * 后台不再复述一遍字段，契约变了这里跟着变。
 */
export type Tenant = StoreConnectionResponse;

/** 内部配置未完成时为 `preparing`，内部标记就绪后为 `ready`。 */

export function isTenantReady(tenant: Tenant): boolean {
  return tenant.status === "ready";
}
